<template>
    <div class="travelagencylist">
        <div class="ranking-tab-wrap">
            <tab :tabList="rankingTab" :name="'rankingTab'" @onSwitch="myPending" ref="guideTab"></tab>
        </div>
        <div class="ranking-tab-wrap cant-click" v-if="loading"></div>
        <div class="wrapper-box">
            <div class="search-box">
                <div class="input-box">
                    <img src="../../assets/travelAgency/ic_search.png" alt class="search-icon" />
                    <input
                        style
                        type="text"
                        placeholder="搜索导游名称或者导游证号"
                        class="search-input"
                        v-model="inputValue"
                    />
                </div>
                <div class="search-btn" @click="search">
                    <div class="label">搜索</div>
                </div>
            </div>
            <div class="choose-box">
                <div class="left-title">
                    <div class="title_box">
                        <div
                            class="titles"
                            v-if ="tabIndex !== 0"
                        >{{tabIndex == 0 ? ' ' : (tabIndex == 2 ? '黑名单监管' : '重点关注')}}全部导游</div>
                        <div
                            v-else
                            class="titles"
                            @click="showAllPicker = true && tabIndex == 0"
                        >{{checkoutValue}}</div>
                        <div class="down">
                            <img
                                v-if="tabIndex == 0"
                                src="../../assets/travelAgency/ic_jiantou_down.png"
                                alt
                                class="down-icon"
                            />
                        </div>
                    </div>
                    <div class="numbers">{{total | filtNum}} 名</div>
                </div>
                <!-- <div class="right-con">
                    <div class="city-box" @click="selfCityId !== 34 ? '' : showPicker = true">
                        <p class="texts">{{cityName}}</p>
                        <img
                            v-if="selfCityId === 34"
                            src="../../assets/travelAgency/ic_jiantou_down1.png"
                            alt
                            class="down-icon"
                        />
                    </div>
                </div> -->
            </div>
            <div class="lists-box">
                <div class="screenList line_bottom">
                    <div class="down" @click="showPicker = true">
                        <!-- <span>{{roleList.OrgInfo.orgRegion + this.cityName}}</span> -->
                        <span>{{this.cityName}}</span>
                        <img
                            src="../../assets/travelAgency/ic_jiantou_down1.png"
                            alt
                            class="down-icon"
                        />
                    </div>
                    <div class="down" @click="typeListPicker = true">
                        <span>{{typeListName}}</span>
                        <img
                            src="../../assets/travelAgency/ic_jiantou_down1.png"
                            alt
                            class="down-icon"
                        />
                    </div>
                </div>
                <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="loadMoreList"
                    v-if="listData.length > 0"
                >
                    <div
                        class="items-box line_bottom"
                        @click="toDetail(items)"
                        v-for="(items,index) in listData"
                        :key="index"
                    >
                        <div
                            class="agency-img"
                            v-if="items.photoPath && items.photoPath !=='' && items.photoPath !=='http://images-1254950508.cosgz.myqcloud.com/a4061d82e-214b-4dd7-b3d8-31361432b131.png'"
                            :style="'background-image:url(' + items.photoPath + ');'"
                        >

                         <p class="wait" v-if="items.state===1"><span>待审核</span></p>
                        </div>
                        <div class="agency-img" v-else :style="'border: 0'"></div>
                        <!-- <div class="agency-img" :style="'background:url(' + items.photoPath + ');background-size: auto 100%;background-position:center;background-repeat: no-repeat;'"></div> -->
                        <!-- <img :src="items.photoPath" alt class="agency-img"/> -->
                        <div class="info-box">
                            <div class="company-name">
                                <div class="name">{{items.name || items.NAME}}</div>
                                <div class="right-tag-box">
                                    <div class="right-tag" v-if="items.isSupervise !== 0">
                                        <div class="label">重点关注</div>
                                    </div>
                                    <div class="right-tag tag-color" v-if="items.isBlacklist != 0">
                                        <div class="label">黑名单</div>
                                    </div>
                                </div>
                            </div>

                            <div class="tag-box">
                                <div class="left-box">
                                    <div class="tags">
                                        <div class="txt">{{items.guideTypeStr}}导游</div>
                                        <star :name="items.certificate" :num="items.guideLevel"></star>
                                    </div>
                                </div>
                            </div>
                            <div class="prices-box">
                                <div class="tags">评分 {{items.guideScore || 0}} 分</div>
                                <div class="tags">投诉 {{items.complaintTime || 0}} 次</div>
                            </div>
                        </div>
                    </div>
                </van-list>
            </div>
            <empty :type="3" v-if="listData.length === 0 && !loading"></empty>
        </div>
        <timePick @getTimeValue="getTimeValue" ref="timePick"></timePick>
        <!-- 城市弹窗 -->
        <van-popup v-model="showPicker" position="bottom">
            <van-picker
                show-toolbar
                :columns="cityColumns"
                @cancel="showPicker = false"
                @confirm="onConfirm"
                value-key="content"
                :default-index="Number(cityIndex)"
            />
        </van-popup>
        <!-- 类型弹窗 -->
        <!-- <van-popup v-model="showTypePicker" position="bottom">
            <van-picker
                show-toolbar
                :columns="typeColumns"
                @cancel="showTypePicker = false"
                @confirm="onTypeConfirm"
            />
        </van-popup> -->
        <van-popup v-model="showAllPicker" position="bottom">
            <van-picker
                show-toolbar
                :columns="typeAllColumns"
                @cancel="showAllPicker = false"
                @confirm="typeAllConfirm"
            />
        </van-popup>
        <!-- 类型选择弹框 -->
        <van-popup v-model="typeListPicker" position="bottom">
            <van-picker
                show-toolbar
                :columns="typeListColumns"
                @cancel="typeListPicker = false"
                @confirm="typeListConfirm"
            />
        </van-popup>
    </div>
</template>
<script>
    import { mapState } from 'vuex';
    import api from '../../service/modules/guide';
    import empty from 'comps/empty';
    import star from 'comps/star';
    import tab from './components/guideTab';
    import timePick from '../../components/base/timePick';
    import util from '../../utils/common';
    import { storageGetByName } from '../../utils/helper';
    export default {
        components: {
            tab,
            star,
            empty,
            timePick
        },

        data () {
            return {
                inputValue: '',
                rankingTab: ['全部', '重点关注', '黑名单监管'],
                showPicker: false,
                cityColumns: [{ content: '全部地区', value: '' }],
                listData: [],
                cityId: '',
                cityName: '全部地区',
                cityIndex: 0,
                tabIndex: 0,
                finished: false,
                loading: false,
                page: 1,
                total: 0,
                selfCityId: 34,
                showAllPicker: false,
                typeAllColumns: ['全部导游', '待审核', '已审核'],
                typeListPicker: false,
                typeListColumns: ['全部', '撤销', '吊销', '注销', '正常'],
                typeListName: '类型',
                contractGuideState: null,
                checkoutValue: '导游',
                state: null,
                roleList: null
            };
        },

        computed: {
            ...mapState('guide', ['history', 'keyword'])
        },

        watch: {},

        methods: {
            getTimeValue () {

            },
            loadMoreList () {
                this.getData();
            },
            onConfirm (params, index) {
                if (params.value) {
                    this.cityId = params.value;
                } else {
                    this.cityId = this.$route.query.cityId;
                }
                this.cityName = params.content;
                this.cityIndex = index;
                this.search();
                this.showPicker = false;
            },
            search () {
                if (this.inputValue && !this.keyword.includes(this.inputValue)) {
                    this.inputValue = this.inputValue.replace(/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g, '');
                    this.$store.dispatch('guide/setKeyword', [
                        this.inputValue,
                        ...this.keyword
                    ]); // 设置搜索记录
                }
                this.total = 0;
                this.listData = [];
                this.page = 1;
                this.getData();
            },
            getData () {
                this.loading = true;
                let type = '';
                switch (this.tabIndex) {
                case 2:
                    type = 'blacklist';
                    break;
                case 1:
                    type = 'supervise';
                    break;
                default:
                    type = '';
                    break;
                }
                let data = {
                    type: type,
                    p: this.page,
                    pageSize: 8,
                    keyword: this.inputValue,
                    city: this.cityId,
                    contractGuideState: this.contractGuideState,
                    state: this.state
                };
                api.guidePage(data).then(res => {
                    if (res.ret === 0) {
                        this.finished = false;
                        this.listData = [...this.listData, ...res.data.list];
                        this.page = res.data.pagination.current_page + 1;
                        this.total = res.data.pagination.total;
                        if (
                            this.total <=
                            res.data.pagination.current_page *
                            res.data.pagination.page_size
                        ) {
                            this.finished = true;
                        }
                        this.loading = false;
                    } else {
                        this.$Toast('请输入合法字符');
                    }
                });
            },
            toDetail (guide) {
                let tmpList = [];
                tmpList.push(guide);
                this.history.forEach(element => {
                    if (element.id !== guide.id && tmpList.length < 10) {
                        tmpList.push(element);
                    }
                });
                this.$store.dispatch('guide/setHistory', tmpList); // 设置浏览记录
                this.$router.push({
                    path: '/guide/info',
                    query: {
                        guideId: guide.id,
                        isBlacklist: guide.isBlacklist,
                        isSupervise: guide.isSupervise,
                        disciplineType: guide.disciplineType
                    }
                });
            },

            myPending (index) {
                this.tabIndex = index;
                if (this.tabIndex === 0) {
                    this.checkoutValue = '导游';
                    this.state = null;
                }
                this.search();
            },
            typeAllConfirm (value) {
                this.showAllPicker = false;
                this.checkoutValue = value;
                if (value === '全部导游' && this.tabIndex === 0) {
                    this.state = null;
                    this.checkoutValue = '导游';
                } else if (value === '待审核' && this.tabIndex === 0) {
                    this.state = 1;
                } else if (value === '已审核' && this.tabIndex === 0) {
                    this.state = 3;
                } else {
                    this.state = null;
                }
                this.listData = [];
                this.getData();
            },
            // 类别筛选弹窗确认
            typeListConfirm (value) {
                this.typeListPicker = false;
                this.typeListName = value;
                if (value === '撤销') {
                    this.contractGuideState = 0;
                } else if (value === '吊销') {
                    this.contractGuideState = 1;
                } else if (value === '注销') {
                    this.contractGuideState = 2;
                } else if (value === '正常') {
                    this.contractGuideState = 3;
                } else if (value === '全部') {
                    this.contractGuideState = '';
                }
                this.listData = [];
                this.getData();
            },
            getCityList () {
                api.guideCityList({ city: 34 }).then(res => { //导游可以看全省
                    if (res.ret === 0) {
                        this.cityColumns = [...this.cityColumns, ...res.data.list];
                    }
                });
            }
        },

        async mounted () {
            // 获取导旅用户权限
            let res = await storageGetByName('guideInfoObj')
            this.roleList = res
            // next
            this.listData = [];
            this.selfCityId = Number(this.$route.query.selfCityId) || 34;
            if (this.selfCityId === 34) {
                this.cityId = this.$route.query.cityId || '';
            } else {
                this.cityId =
                    this.$route.query.selfCityId || this.$route.query.cityId || '';
            }
            this.cityId =
                this.cityId === 34 || this.cityId === '34' ? '' : this.cityId;
            this.tabIndex = this.$route.query.tabIndex ? Number(this.$route.query.tabIndex) : 0;
            this.cityIndex = this.$route.query.cityIndex || 0;
            this.cityName = decodeURIComponent(this.$route.query.cityName) || '全部地区';
            // if(this.roleList.OrgInfo.orgRegion.indexOf(decodeURIComponent(this.$route.query.cityName))>-1){
            //     this.cityName=''
            // }
            // this.cityName = this.cityName === '云南省' ? '全部地区' : this.cityName;
            this.getCityList();
            // if (this.tabIndex === 1) {
            //     this.tabIndex = 2;
            // } else if (this.tabIndex === 2) {
            //     this.tabIndex = 1;
            // }
            this.$refs.guideTab.switchTab(this.tabIndex);
        },
        created () {},
        filters: {
            filtNum (value) {
                return (+value || 0).toString().replace(/^-?\d+/g, (m) => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','));
            }
        }
    };
</script>
<style scoped lang="less">
@vv: 3.75vw;
.travelagencylist {
    background: #fbfbfb;
    height: 100%;
    .backnav-box {
        height: 44 / @vv;
        background: rgba(54, 179, 116, 1);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;

        .back-icon {
            position: absolute;
            width: 10 / @vv;
            height: 16 / @vv;
            top: 14 / @vv;
            left: 20 / @vv;
        }

        .backnav-text {
            font-size: 16 / @vv;

            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            line-height: 16 / @vv;
        }
    }

    .ranking-tab-wrap {
        width: 100%;
        position: fixed;
        top: 0;
        background: #fbfbfb;
        padding: 0 12 / @vv;
        z-index: 999;
        .data-card-tab {
            margin-bottom: 24 / @vv;
        }
        &.cant-click {
            z-index: 1000;
            height: 65 / @vv;
            opacity: 0;
        }
    }
    .wrapper-box {
        box-sizing: border-box;
        padding: 69 / @vv 12 / @vv 0;

        .search-box {
            height: 28 / @vv;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 12 / @vv;
            // padding-top: 65/@vv;

            .input-box {
                flex: 1;
                margin-right: 12 / @vv;
                height: 100%;
                display: flex;
                align-items: center;
                box-sizing: border-box;
                padding-left: 16 / @vv;
                background: rgba(245, 245, 245, 1);
                border-radius: 1 / @vv;

                .search-icon {
                    width: 15 / @vv;
                    // height: 14/@vv;
                    margin-right: 8 / @vv;
                }

                input::-webkit-input-placeholder {
                    font-size: 12 / @vv;

                    font-weight: 400;
                    color: rgba(153, 153, 153, 1);
                    line-height: 17 / @vv;
                }

                .search-input {
                    flex: 1;
                    background: rgba(245, 245, 245, 1);
                }
            }

            .search-btn {
                width: 40 / @vv;
                height: 28 / @vv;
                background: rgba(245, 245, 245, 1);
                border-radius: 1 / @vv;
                font-size: 12 / @vv;

                font-weight: 400;
                color: rgba(54, 179, 116, 1);
                // line-height: 28/@vv;
                // text-align: center;
                display: table;
                .label {
                    display: table-cell;
                    vertical-align: middle;
                    text-align: center;
                }
            }
        }

        .choose-box {
            height: 44 / @vv;
            display: flex;
            align-items: center;

            .left-title {
                height: 20 / @vv;
                display: flex;
                align-items: flex-end;
                width: 100%;
                justify-content: space-between;
                .title_box {
                    display: flex;
                    align-items: center;
                    .titles {
                        font-size: 20 / @vv;
                        font-family: PingFang SC, Arial, sans-serif;
                        -webkit-font-smoothing: antialiased;
                        font-weight: bold;
                        color: rgba(51, 51, 51, 1);
                        line-height: 20 / @vv;
                    }

                    .numbers {
                        font-size: 12 / @vv;

                        font-weight: 400;
                        color: rgba(102, 102, 102, 1);
                        line-height: 14 / @vv;
                    }
                }
                .down {
                    display: flex;
                    height: 100%;
                    align-items: center;
                    margin-left: 4px;
                    img {
                        width: 6px;
                        height: 4px;
                        margin-top: 5px;
                    }
                }
            }

            .right-con {
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                box-sizing: border-box;
                padding-top: 8 / @vv;

                .city-box {
                    display: flex;
                    align-items: center;
                    height: 44 / @vv;
                    margin-left: 16 / @vv;

                    .texts {
                        font-size: 12 / @vv;

                        font-weight: 400;
                        color: rgba(102, 102, 102, 1);
                        line-height: 44 / @vv;
                        margin-right: 5 / @vv;
                    }

                    .down-icon {
                        width: 6 / @vv;
                        height: 4 / @vv;
                    }
                }
            }
        }

        .lists-box {
            background: rgba(255, 255, 255, 1);
            box-shadow: 0 / @vv 0 / @vv 10 / @vv 0 / @vv rgba(0, 0, 0, 0.04);
            border-radius: 3 / @vv;
            .screenList {
                padding: 16px;
                display: flex;
                .down {
                    display: flex;
                    align-items: center;
                    font-size: 12px;
                    color:#666666;
                    margin-right: 32px;
                    img {
                        width: 6px;
                        height: 4px;
                        margin-left: 5px;
                    }
                }
            }
            .items-box {
                display: flex;
                align-items: center;
                box-sizing: border-box;
                padding: 16 / @vv 10 / @vv 16 / @vv 16 / @vv;
                // border-bottom: 1/@vv solid #eeeeee;

                &:last-child {
                    border-bottom: none;
                }

                .agency-img {
                    width: 64 / @vv;
                    height: 64 / @vv;
                    margin-right: 12 / @vv;
                    background: url(../../assets/travelAgency/ic_bm_cy1.png);
                    border-radius: 3 / @vv;
                    border: 1 / @vv solid rgba(238, 238, 238, 1);
                    background-size: auto 100%;
                    background-position: center;
                    background-repeat: no-repeat;
                    position: relative;
                    box-sizing: border-box;
                    //  object-fit: cover;
                    //  background-size: 84/@vv auto;
                    //  background-repeat: no-repeat;
                    .wait{
                        position: absolute;
                        left:0;
                        bottom:0;
                        width:100%;
                        height:18px;
                        background-color: #36B374;
                        text-align: center;
                        line-height: 18px;
                        color:#fff;
                        border-radius: 0 0 3 / @vv 3 / @vv;
                        font-size:0;
                        span{
                            display: inline-block;
                            font-size:11px;
                            transform: scale(0.9);
                            margin-top:1px;
                        }
                    }
                }

                .info-box {
                    flex: 1;
                    height: 64 / @vv;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    .company-name {
                        display: flex;
                        justify-content: space-between;
                        position: relative;
                        .name {
                            font-size: 14 / @vv;
                            font-family: PingFang SC, Arial, sans-serif;
                            -webkit-font-smoothing: antialiased;
                            font-weight: bold;
                            color: rgba(51, 51, 51, 1);
                            line-height: 20 / @vv;
                        }
                        .right-tag-box {
                            position: absolute;
                            display: flex;
                            align-items: center;
                            transform: scale(0.5);
                            transform-origin: right 0;
                            flex: 1;
                            justify-content: flex-end;
                            top: 0;
                            right: 6 / @vv;
                            .right-tag {
                                display: table;
                                padding: 0 8 / @vv;
                                text-align: center;
                                margin-left: 16 / @vv;
                                min-width: 96 / @vv;
                                height: 34 / @vv;
                                // line-height: 34/@vv;
                                background: rgba(255, 140, 25, 1);
                                // border-radius:1/@vv;
                                font-size: 20 / @vv;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: rgba(255, 255, 255, 1);
                                .label {
                                    height: 34 / @vv;
                                    line-height: 34 / @vv;
                                    display: table-cell;
                                    vertical-align: middle;
                                    white-space: nowrap;
                                }
                            }
                            .tag-color {
                                background: rgba(255, 77, 77, 1);
                            }
                        }
                    }

                    .tag-box {
                        height: 14 / @vv;
                        display: flex;
                        align-items: center;
                        margin: 8 / @vv 0;

                        .left-box {
                            flex: 1;
                            display: flex;

                            .tags {
                                display: flex;
                                align-items: center;
                                .txt {
                                    font-size: 12 / @vv;
                                    font-family: PingFangSC-Regular, PingFang SC;
                                    font-weight: 400;
                                    color: rgba(153, 153, 153, 1);
                                    margin-right: 4 / @vv;
                                }
                            }
                        }
                    }

                    .prices-box {
                        display: flex;
                        align-items: center;

                        .tags {
                            font-size: 10 / @vv;

                            font-weight: 400;
                            color: rgba(102, 102, 102, 1);
                            line-height: 14 / @vv;
                            box-sizing: border-box;
                            padding-left: 7 / @vv;
                            padding-right: 8 / @vv;
                            border-right: 1 / @vv solid #979797;
                            // margin-right: 7/@vv;

                            &:first-child {
                                padding-left: 0;
                            }

                            &:last-child {
                                border-right: none;
                                margin-right: 0;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
